import { GetWidgetConversationResponse, GlobalParticipantType } from '@vendasta/conversation';

export function isLeadCaptured(data: GetWidgetConversationResponse): boolean {
  return data?.conversation.subjectParticipants.some(
    (p) => p.participantType === GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_CUSTOMER,
  );
}

export function isAnonymous(data: GetWidgetConversationResponse): boolean {
  return data?.conversation.subjectParticipants.some(
    (p) => p.participantType === GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_ANONYMOUS,
  );
}
